import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('✅ SW готов к работе')
    },
    registered(registration) {
      console.log('✅ SW зарегистрирован')
      setInterval(() => {
        registration.update()
      }, 1000 * 60 * 60)
    },
    cached() {
      console.log('✅ Контент закэширован')
    },
    updatefound() {
      console.log('🔄 Найдено обновление, загружается...')
    },
    updated(registration) {
      console.log('🆕 Новая версия готова!')
      
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )
    },
    offline() {
      console.log('📴 Офлайн режим')
    },
    error(error) {
      console.error('❌ Ошибка SW:', error)
    }
  })
}